import { identity } from "@workspace/mobile";
import { ApplicationSettings } from "../../constants";
import { CollinsUser } from "../../types/user";
import { getEnvironmentProps } from "../../utils/environment";
import { RootQuery, RootMutation } from "./types";
import { dmnIdentity } from "../../utils/dmnIdentity";
import { errorHandler, apiFetchNotOkHandler } from "../../APIs/errorHandler";

export type GraphResponse = {
  data: RootQuery | RootMutation;
};

interface GraphQuery {
  query: string;

  variables: any;
}

//Generic function to perform an ajax call to the Workspace api
export async function queryGraph(query: GraphQuery): Promise<GraphResponse> {
  //Retrieve the user access token from the bridge.
  const token = await identity.getAccessToken();
  const environmentVars = getEnvironmentProps(token);

  try {
    const response = await fetch(`${environmentVars?.WORKSPACE_GRAPHQL_API}`, {
      method: "POST",
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(query)
    });

    if (!response.ok) {
      apiFetchNotOkHandler(response, "Error fetching user information");
      return { data: {} };
    }

    const data = await response.json();

    return data;
  } catch (error) {
    errorHandler(error, "Error fetching user information");
    return { data: {} };
  }
}

export async function getCollinsUserInfo() {
  //perform any actions to get user information, etc, required for bootstrap
  //example below calling Workspace Graph API to get the signed in user information
  const token = await dmnIdentity.getAccessToken();
  const environmentVars = getEnvironmentProps(token);

  const response = await fetch(`${environmentVars?.AUTH_API_BASE_URL}/me`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`
    }
  });

  if (response && response.ok) {
    const data = await response.json();
    return data.payload as CollinsUser;
  }
  return null;
}

export function getUserInfo(): Promise<GraphResponse | undefined> {
  //perform any actions to get user information, etc, required for bootstrap
  //example below calling Workspace Graph API to get the signed in user information
  return queryGraph({
    query: `query GetUserInfo($applicationId: ID!) {
            users {
                id
                firstName
                lastName
                emailAddress
                jobTitle
                office
                organisationUser {
                    organisation {
                        id
                        name
                    }
                }
                applicationUsers(applicationId: $applicationId) {
                    role {
                        id
                        name
                    }
                    applicationSubscription {
                        id
                        application {
                            id
                            name
                        }
                    }
                }
                avatar {
                    id
                    sizes {
                        size
                        url
                    }
                }
            }
        }`,
    variables: {
      // Ensure that your application id is set correctly
      applicationId: ApplicationSettings.ApplicationId
    }
  });
}
